<div class="w-full h-full">
  <!-- Conditionally render the empty state if no data is available -->
  @if (!isDataAvailable && !isLoading) {
    <m-not-available></m-not-available>
  }
  <!-- Conditionally render the chart component when data is ready -->
  @if (isDataAvailable && isChartReady) {
    <m-line-chart
      [options]="multiLineChartOptions"
      class="w-full"
      [height]="350"></m-line-chart>
  }
  <!-- Loading state -->
  @if (isLoading) {
    <div>
      <m-skeleton width="100%" height="18.75rem"></m-skeleton>
    </div>
  }
</div>
